// extracted by mini-css-extract-plugin
module.exports = {"root":"KCJFOY","title":"vRLOg2","subtitle":"ofuDq7"};